export var Broker;
(function (Broker) {
    Broker["InteractiveBrokers"] = "Interactive Brokers";
    Broker["Trading212"] = "Trading 212";
    Broker["DEGIRO"] = "DEGIRO";
})(Broker || (Broker = {}));
export const brokers = [
    Broker.InteractiveBrokers,
    Broker.Trading212,
    Broker.DEGIRO,
];
